import { useTranslation } from 'react-i18next';

import Errors from 'components/Errors/Errors';
import Editor from 'components/TestEditor/Editor';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './QuizQuestionTitleContent.scoped.scss';

interface QuizQuestionTitleContentProps {
  onTitleChange?: (title: string) => void;
  onContentChange?: (content: string) => void;
  title: string;
  content: string;
  validation: object;
}
const QuizQuestionTitleContent = (props: QuizQuestionTitleContentProps) => {
  const { title, content, validation, onContentChange, onTitleChange } = props;
  const { t } = useTranslation();

  return (
    <form className="new-quiz-form">
      <div className="form-group">
        <label className="form-label label-required" htmlFor="name">
          {t('quiz:Question.Description')}
          <span>*</span>
        </label>
        <input
          className="form-input"
          type="text"
          name="name"
          placeholder={t('quiz:Question.DescriptionPlaceholder')}
          value={title}
          onChange={e => onTitleChange(e.target.value)}
          onBlur={e => onTitleChange(e.target.value)}
        />
        <Errors errors={validation} prop={'model.title'} />
      </div>

      <div className="form-group">
        <label className="form-label label-required" htmlFor="name">
          {t('quiz:Question.Content')}
        </label>
        <Editor value={content || ''} callback={val => onContentChange(val)} />
      </div>
    </form>
  );
};

export default QuizQuestionTitleContent;
